module.exports = __WEBPACK_EXTERNAL_MODULE_107__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/events/Event","root":["openfl","events","Event"],"commonjs":"openfl/events/Event","commonjs2":"openfl/events/Event"}
// module id = 107
// module chunks = 0